exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.linea-pedido-param-label[data-v-2f4d6b64] {\n    font-weight: bold;\n}\n.linea-pedido-param[data-v-2f4d6b64] {\n    flex: 1 1 50%;\n}\n", ""]);
